/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import "./style.css";

export const BtnMenuMore = ({
  status,
  color,
  className,
  regularMenuDots = "/img/regular-menu-dots-3.svg",
}) => {
  return (
    <div className={`btn-menu-more status-6-${status} ${className}`}>
      {status === "on" && (
        <div className="regular-menu-dots-wrapper">
          <svg
            width={27}
            height={27}
            viewBox="0 0 27 27"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.96354 15.1668C5.88402 15.1668 6.63021 14.4206 6.63021 13.5002C6.63021 12.5797 5.88402 11.8335 4.96354 11.8335C4.04307 11.8335 3.29688 12.5797 3.29688 13.5002C3.29688 14.4206 4.04307 15.1668 4.96354 15.1668Z"
              fill={color}
            />
            <path
              d="M13.2965 15.1668C14.217 15.1668 14.9632 14.4206 14.9632 13.5002C14.9632 12.5797 14.217 11.8335 13.2965 11.8335C12.3761 11.8335 11.6299 12.5797 11.6299 13.5002C11.6299 14.4206 12.3761 15.1668 13.2965 15.1668Z"
              fill={color}
            />
            <path
              d="M21.6305 15.1668C22.551 15.1668 23.2972 14.4206 23.2972 13.5002C23.2972 12.5797 22.551 11.8335 21.6305 11.8335C20.7101 11.8335 19.9639 12.5797 19.9639 13.5002C19.9639 14.4206 20.7101 15.1668 21.6305 15.1668Z"
              fill={color}
            />
          </svg>
        </div>
      )}

      {status === "off" && (
        <svg
          width={27}
          height={27}
          viewBox="0 0 27 27"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.96354 15.1668C5.88402 15.1668 6.63021 14.4206 6.63021 13.5002C6.63021 12.5797 5.88402 11.8335 4.96354 11.8335C4.04307 11.8335 3.29688 12.5797 3.29688 13.5002C3.29688 14.4206 4.04307 15.1668 4.96354 15.1668Z"
            fill={color}
          />
          <path
            d="M13.2965 15.1668C14.217 15.1668 14.9632 14.4206 14.9632 13.5002C14.9632 12.5797 14.217 11.8335 13.2965 11.8335C12.3761 11.8335 11.6299 12.5797 11.6299 13.5002C11.6299 14.4206 12.3761 15.1668 13.2965 15.1668Z"
            fill={color}
          />
          <path
            d="M21.6305 15.1668C22.551 15.1668 23.2972 14.4206 23.2972 13.5002C23.2972 12.5797 22.551 11.8335 21.6305 11.8335C20.7101 11.8335 19.9639 12.5797 19.9639 13.5002C19.9639 14.4206 20.7101 15.1668 21.6305 15.1668Z"
            fill={color}
          />
        </svg>
      )}

      <div className="text-wrapper-9">More</div>
    </div>
  );
};

BtnMenuMore.propTypes = {
  status: PropTypes.oneOf(["off", "on"]),
  regularMenuDots: PropTypes.string,
};
